/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdrop2.vue?vue&type=template&id=a5accb5e&scoped=true"
import script from "./airdrop2.vue?vue&type=script&lang=js"
export * from "./airdrop2.vue?vue&type=script&lang=js"
import style0 from "./airdrop2.vue?vue&type=style&index=0&id=a5accb5e&prod&lang=scss"
import style1 from "./airdrop2.vue?vue&type=style&index=1&id=a5accb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5accb5e",
  null
  
)

export default component.exports